<template>
    <div style="color: black; z-index: 90;  top: 0; left: 0; right: 0; bottom: 0 " :style="{'position': inline == true ? 'initial' : 'absolute', 'background-color' : backgroundColor}">
        <div class="text-center" style="margin-bottom: 25px;" :style="{'margin-top': marginTop + 'px' }">
        <img v-if="showAll" src="/static/img/assets/setting/premium_alert.png" alt="" style="width: 100%; max-width: 300px">
        <h3 style="text-shadow: 1px 1px 20px #9e9e9e;">It's time to upgrade.</h3>
        <p style="text-shadow: 1px 1px 20px #9e9e9e;">Upgrade Your Plan to use PREMIUM features , only 500 THB/month</p>
        <router-link to="/setting?tab=billing" class="btn btn-primary">Upgrade your plan</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'showAll' : {
                default: true
            },
            'inline' : {
                default: false
            },
            'marginTop': {
                default: 0
            },
            backgroundColor: {
                default: '#dcd9d9a8'
            }
        } 
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/PremiumPlanPopup.vue